import parentService from "@/services/ParentService";
import {Message} from 'element-ui';

export const parentStore = {
    namespaced: true,
    state: {
        parentList: [],
        isLoading: false,
        totalPage: null,
    },
    getters: {},
    mutations: {
        SET_PARENT_LIST: (state, data) => {
            state.parentList = data;
        },

        SET_IS_LOADING: (state, boolean) => {
            state.isLoading = boolean;
        },

        SET_TOTAL_PAGE: (state, total) => {
            state.totalPage = total;
        },
    },
    actions: {
        /**
         * fetch dữ liệu filter danh sách phụ huynh
         *
         * @param commit
         * @param {number} page - số trang
         * @param {number} limit - số lượng phần tử trong 1 trang
         * @param {string} status - trạng thái của học sinh
         * @param {number} idGrade - id của khối
         * @param {number} idClass - id của lớp
         * @param {string} nameOrPhone - tên hoặc số điện thoại
         *
         * */
        fetchFilterManagerParent: ({commit}, {page, limit, status, idGrade, idClass, nameOrPhone}) => {
            commit('SET_IS_LOADING', true);
            parentService.filterParent(page, limit, status, idGrade, idClass, nameOrPhone)
                .then((res) => {
                    const data = res.data.data;
                    commit('SET_PARENT_LIST', data.childrenOfParentsResponseList);
                    commit('SET_TOTAL_PAGE', data.totalPage);
                })
                .catch((err) => {
                    console.error(err);
                    Message({
                        message: "Lỗi dữ liệu!",
                        type: "error",
                        duration: 5000
                    })
                })
                .finally(() => {
                    commit("SET_IS_LOADING", false);
                })
        },
    }
}